import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './ValidateInfo.module.scss';
import { FaIcon } from 'components/ui';

export interface IValidateInfo extends HTMLAttributes<HTMLDivElement> {
  isValid?: boolean;
}

const ValidateInfo: FC<IValidateInfo> = (props) => {
  const { isValid, className, children } = props;
  const rootClassName = classNames(styles.root, className, { [styles.valid]: isValid });

  return (
    <div className={rootClassName}>
      {isValid ? (
        <FaIcon className={styles.icon} icon='check-circle' />
      ) : (
        <FaIcon className={styles.icon} icon='times-circle' iconPrefix='far' />
      )}
      <span className={styles.text}>{children}</span>
    </div>
  );
};

export default ValidateInfo;
